export default {
	wrapper: {
		maxWidth: 1680,
		width: '100%',
		margin: [[0, 'auto']],
	},
	row: {
		padding: [[80, '10%', 0, '10%']],
		marginBottom: 0,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 87,
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		backgroundColor: 'transparent',
		'@media(max-width: 950px)': {
			padding: [[60, '10%', 0, '10%']],
			flexDirection: 'column',
		},
	},
	noPaddingMaxWidth: {
		'@media(min-width: 1800px)': {
			padding: '60px 0% 0 0% !important',
		},
	},
	marginBottomBig: {
		marginBottom: 65,
	},
	textWrapper: {
		alignSelf: 'flex-start',
		display: 'inline-block',
		margin: [['auto', 0]],
		float: 'left',
	},
	subHeader: {
		padding: [[20, 0]],
	},
	textRight: {
		order: 2,
	},
	titleCenter: {
		'@media(max-width: 950px)': {
			textAlign: 'center',
		},
	},
	subHeadingWrapper: {
		paddingRight: '30%',
		marginBottom: 30,
		marginTop: 15,
		lineHeight: '24px',
		'@media(max-width: 950px)': {
			paddingRight: 0,
			textAlign: 'center',
		},
	},
	noPaddingRight: {
		paddingRight: 0,
	},
	buttonContainer: {
		margin: [[20, 'auto', 60, 'auto']],
	},
	linkWrapper: {
		width: 200,
		height: 42,
		order: 2,
		'@media(max-width: 950px)': {
			margin: [[0, 'auto', 40, 'auto']],
			width: 160,
			marginTop: 40,
		},
		'@media(max-width: 400px)': {
			width: 140,
			marginTop: 40,
		},
	},
	imageWrapper: {
		width: '55%',
		display: 'inline-block',
		'@media(max-width: 950px)': {
			order: 2,
			width: '100%',
		},
	},
	image: {
		width: '100%',
	},
	iframeContainer: {
		position: 'relative',
		width: '100%',
		height: 0,
		paddingBottom: '56.25%',
	},
	iframe: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		border: 'none',
	},
	titleWrapper: {
		margin: [[0, 'auto']],
	},
	connectContainer: {
		flexDirection: 'column',
		paddingTop: 60,
	},
	buttons: {
		display: 'flex',
		justifyContent: 'center',
		padding: [[40, 0]],
	},
	buttonWrapper: {
		marginRight: 25,
	},
	iconsWrapper: {
		display: 'flex',
		justifyContent: 'space-around',
		padding: [[60, 0, 40, 0]],
		flexWrap: 'wrap',
	},
	iconWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: 200,
		textAlign: 'center',
		marginBottom: 10,
	},
	iconLabel: {
		marginTop: 10,
	},
}
